import { ContactMailTwoTone } from "@mui/icons-material";

const ContactMailIcon = () => {
  return <ContactMailTwoTone />;
};

export default ContactMailIcon;
